module.exports = __webpack_public_path__ + "static/Advancement_Initiative_Logo_Black-221d308cc25e4ac9bc87aca4931468cf.png";